import request from '../request';

export default {
  getUploadFileToken(data) {
    return request.get(`/upload/getToken`, data);
  },
};
